// extracted by mini-css-extract-plugin
module.exports = {"menus":"index_menus_2qo2i","icon":"index_icon_13j1k","title":"index_title_1FZm_"};